export const environment = {
  production: true,
  apiUrl: 'https://staging-mb-api.adcore.com',
  adcoreUI: 'https://staging-mb.adcore.com',
  exportFeedUrl: 'https://staging-mb-api.adcore.com/public/feeditor/export',
  adcoreFacebookUI: 'https://myfeed.adcore.com',
  adcoreOldUI: 'https://staging-mb.adcore.com/old_ui',
  feeditorPlusRoot: 'https://plus-stage.feeditor.com',
  stripePublishableKey: 'pk_test_51QA28GEOdKoQ9t5HnfLRecQAOs0xkWbGiy1Y5eoBQcYvnWk8lJubPUYMshb67J4GBd2xVXKuwIbUZJKIPWhIc13v000D83GaQa',
  publicAccessToken: 'kTaNecU9cKgERij1xKLMfHPvIgEOyntf4cw7lVznlr0YD6fOs0ZSZdX5Tcaif0mj',
};
